export type Signal = 'up' | 'down' | 'neutral'

/** 上昇確率からシグナルを返す（全コンポーネント共通の閾値） */
export function getSignal(prob: number): Signal {
  if (prob > 0.65) return 'up'
  if (prob < 0.35) return 'down'
  return 'neutral'
}

export const SIGNAL_TEXT: Record<Signal, string> = {
  up:      '強気',
  down:    '弱気',
  neutral: '中立',
}

export const SIGNAL_ARROW: Record<Signal, string> = {
  up:      '↑',
  down:    '↓',
  neutral: '→',
}

export const SIGNAL_TEXT_COLOR: Record<Signal, string> = {
  up:      'text-trading-green',
  down:    'text-trading-red',
  neutral: 'text-trading-yellow',
}

export const SIGNAL_BG_COLOR: Record<Signal, string> = {
  up:      'bg-trading-green',
  down:    'bg-trading-red',
  neutral: 'bg-trading-yellow',
}
